module.exports = __webpack_public_path__ + "img/Oh.874a1cea.svg";